<template>
  <el-container>
    <el-form label-width="90px">
      <el-form-item label="报警代码:">{{rowData.warning ? rowData.warning.warning_code : ''}}</el-form-item>
      <el-form-item label="报警名称:">{{rowData.warning ? rowData.warning.warning_name : ''}}</el-form-item>
      <el-form-item label="报警描述:">
        <el-input v-model="rowData.warning.warning_desp" type="textarea" rows="5" readonly />
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>

export default {
  props: ['rowData']
}
</script>
